<template>
	<div class="p-6">
		<p class="font-medium text-gray-700">{{ __("Auktion") }}</p>

		<div class="flex space-x-4 justify-between mt-3">
			<ui-input-group
				class="grow"
				v-model="form.auction.price"
				field="auction.price"
				label="Price"
				suffix="EUR/t"
				:form="form"
				:dp="2"
			></ui-input-group>

			<ui-input-group
				class="grow"
				v-model="form.auction.qty_mt"
				field="auction.qty_mt"
				label="Quantity"
				suffix="t"
				:form="form"
				:dp="0"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {},
};
</script>
